import angular from 'angular';
import _ from 'underscore';

import config from 'src/config';
import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function CustomerEditCtrl($scope, $q, $state, $stateParams, $timeout, sdkUtils, utilsService, managementUserService, alertService, organizationService, customerService, formHelpersService, ERROR_MESSAGES, loggerService, monthService, venueService, TRACKING_EVENT_CATEGORIES, analyticsService, modalService, $sce) { //eslint-disable-line
  const currentUser = managementUserService.getCurrentUser();
  const currentUserOrganization = organizationService.getCurrentOrganization();

  if (!currentUser) {
    alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_CURRENT_USER);
    return;
  }

  if (!currentUserOrganization) {
    alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION);
    return;
  }

  _initScope();

  const dataPromises = [
    _getVenues()
  ];

  if ($stateParams.id) dataPromises.push(_getCustomer());

  $q.all(dataPromises)
    .then(() => {
      if (!$scope.editMode) {
        $scope.customerForm = {
          enable: true,
          venues: []
        };
      } else if ($scope.customer.venues) {
        $scope.customerForm.venues = _.filter($scope.venues, venue => {
          return _.contains($scope.customer.venues, venue.id);
        });
      }
    })
    .finally(() => {
      $scope.loading = false;
    });

  function _initScope() {
    $scope.loading = true;
    $scope.customerId = $stateParams.id;
    $scope.customerForm = {};
    $scope.editMode = $scope.customerId ? true : false; //eslint-disable-line

    $scope.helpCenterUrl = `${$sce.trustAsResourceUrl(config.HELP_CENTER_URL)}/hc/en-us/articles/115002791046`;

    //enums
    $scope.TRACKING_EVENT_CATEGORIES = TRACKING_EVENT_CATEGORIES;

    //dropdown data
    $scope.months = monthService.list();
    $scope.currentYear = (new Date()).getFullYear();

    $scope.createOrUpdateCustomer = _createOrUpdateCustomer;

    $scope.sections = {
      BASIC: 'BASIC',
      ADVANCED: 'ADVANCED',
      SOCIAL: 'SOCIAL',
      FRAUD: 'FRAUD'
    };
    $scope.currentSection = $scope.sections.BASIC;

    $scope.updateFraudStatusOverride = function(fraudStatusOverride, $event) {
      if ($event) $event.preventDefault();

      modalService.confirmation({
          modalHeader: `Update fraud status for customer ${$scope.customer.name}`,
          modalMessage: `Are you sure you want to mark this customer as ${fraudStatusOverride.toLowerCase()}?`,
          confirmBtnTxt: `Mark as ${fraudStatusOverride.toLowerCase()}`,
          confirmingBtnTxt: 'Updating...',
          confirmingBtnClass: fraudStatusOverride === 'GOOD' ? 'btn-success' : 'btn-danger',
          size: 'sm'
        })
        .then(result => {
          if (result && result.confirm) {
            customerService.updateByIdAndOrganizationId($scope.customerId, currentUserOrganization.id, {
                fraudStatusOverride: fraudStatusOverride
              })
              .then(updatedCustomer => {
                $scope.customer = _.extend($scope.customer, updatedCustomer);

                alertService.success('Fraud Status has been updated');
              })
              .catch(response => {
                alertService.error(sdkUtils.getErrorFromResponse(response));
              })
              .finally(() => {
                result.modalInstance.close();
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    };

    if ($stateParams.section && $scope.sections[$stateParams.section]) {
      $scope.currentSection = $scope.sections[$stateParams.section];
    }
  }

  function _getCustomer() {
    return customerService.readByIdAndOrganizationId($scope.customerId, currentUserOrganization.id)
      .then(customer => {
        $scope.customer = customer;

        $scope.customerForm = _mapCustomerDataToForm();
      })
      .catch(response => {
        if (response && response.status !== 404) {
          const errorMsg = sdkUtils.getErrorFromResponse(response);

          if (errorMsg) loggerService.error(errorMsg);

          alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_STAFF_BY_ID);
        }
      });
  }

  /**
   * @desc Create or update a staff member
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  function _createOrUpdateCustomer(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    const customerCreateOrUpdateData = _mapChangedFormValuesToApiData(form);

    $scope.savingCustomer = true;

    let createOrUpdateCustomerPromise;

    if ($scope.editMode) createOrUpdateCustomerPromise = customerService.updateByIdAndOrganizationId($scope.customerId, currentUserOrganization.id, customerCreateOrUpdateData);
    else createOrUpdateCustomerPromise = customerService.createByOrganizationId(currentUserOrganization.id, customerCreateOrUpdateData);

    return createOrUpdateCustomerPromise
      .then(() => {
        if ($scope.editMode) alertService.success('Customer updated');
        else {
          _trackCustomerCreated();

          alertService.success('Customer created');

          $state.go('app.organization.customerDatabase');
        }
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        $scope.savingCustomer = false;
      });
  }

  /**
   * @desc Maps a hash of values to how the API expects the data to be
   */
  function _mapChangedFormValuesToApiData(form) {
    if (!form) return null;

    let changedValues;
    const customerData = {};

    if (!$scope.editMode) {
      changedValues = $scope.customerForm;

      //because we have to send up a venueId to the API (because customers have to be accessed by org-relationships)
      //we need a venueId for the organizaion the user is in
      //so find the first venue the user is in, that is also in the organizaiton they are in (excluded any org-relationship venues)
      const firstOrganizationVenue = _.findWhere($scope.venues, {
        organization: currentUserOrganization.id
      });

      customerData.venueId = firstOrganizationVenue.id;
    } else {
      changedValues = formHelpersService.getChangedFormValues(form);
    }

    if ('name' in changedValues) customerData.name = changedValues.name;
    if ('email' in changedValues) customerData.email = changedValues.email;
    if ('venues' in changedValues) customerData.venueIds = (changedValues.venues || []).map(venue => venue.id);
    if ('phone' in changedValues) {
      if (changedValues.phone) {
        changedValues.phone = changedValues.phone.replace(/\D/g, '');
      }

      customerData.phone = changedValues.phone ? changedValues.phone : null;
    }
    if ('profileImage' in changedValues) customerData.profileImage = changedValues.profileImage;
    if ('birthdayDay' in changedValues) customerData.birthdayDay = changedValues.birthdayDay;
    if ('birthdayMonth' in changedValues) customerData.birthdayMonth = changedValues.birthdayMonth;
    if ('birthdayYear' in changedValues) customerData.birthdayYear = changedValues.birthdayYear;
    if ('gender' in changedValues) customerData.gender = changedValues.gender;
    if ('vip' in changedValues) customerData.vip = changedValues.vip;
    if ('tags' in changedValues) {
      if (changedValues.tags && changedValues.tags.length) {
        changedValues.tags = _.unique(changedValues.tags);
      }
      customerData.tags = changedValues.tags && changedValues.tags.join ? changedValues.tags.join(',') : null;
    }
    if ('nationality' in changedValues) customerData.nationality = changedValues.nationality;
    if ('notes' in changedValues) customerData.notes = changedValues.notes;
    if (('facebook' in changedValues) || ('twitter' in changedValues) || ('linkedin' in changedValues) || ('youtube' in changedValues) || ('instagram' in changedValues)) {
      customerData.social = {};
      if ('facebook' in changedValues) customerData.social.facebook = changedValues.facebook;
      if ('twitter' in changedValues) customerData.social.twitter = changedValues.twitter;
      if ('linkedin' in changedValues) customerData.social.linkedin = changedValues.linkedin;
      if ('youtube' in changedValues) customerData.social.youtube = changedValues.youtube;
      if ('instagram' in changedValues) customerData.social.instagram = changedValues.instagram;
    }

    return customerData;
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'location',
          'schedule',
          'slug'
        ].join(',')
      })
      .then(venues => {
        $scope.venues = venues;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  /**
   * @desc Maps the $scope.venue to an object the UI will bind to
   * @return Object
   */
  function _mapCustomerDataToForm() {
    let customerEditData = {};

    customerEditData = angular.copy($scope.customer);

    if (customerEditData.social) {
      customerEditData.facebook = customerEditData.social.facebook;
      customerEditData.twitter = customerEditData.social.twitter;
      customerEditData.linkedin = customerEditData.social.linkedin;
      customerEditData.youtube = customerEditData.social.youtube;
      customerEditData.instagram = customerEditData.social.instagram;
    }
    if (customerEditData.tags && customerEditData.tags.length) {
      customerEditData.tags = _.unique(customerEditData.tags);
    }

    return customerEditData;
  }

  function _trackCustomerCreated() {
    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_CUSTOMER, {
      category: TRACKING_EVENT_CATEGORIES.CUSTOMERS
    });
  }
}

CustomerEditCtrl.$inject = [
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$timeout',
  'jsSdk.utils',
  'utilsService',
  'jsSdk.managementUser',
  'alertService',
  'organizationService',
  'jsSdk.customer',
  'formHelpersService',
  'ERROR_MESSAGES',
  'loggerService',
  'monthService',
  'jsSdk.venue',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  'modalService',
  '$sce'
];

export default CustomerEditCtrl;



// WEBPACK FOOTER //
// ./src/components/customerEdit/customerEditCtrl.js